/**
 * Shared inline SVG icon markup used by more than one module, so every
 * close ("X") button across the app — the mobile category menu toggle, the
 * photo modal, and the blog modal — renders the exact same icon rather than
 * three subtly different hand-copied versions.
 */

export const CLOSE_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
